import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { RULE_REC_TYPE } from '../../../constants';
import SnackStore from '../../../stores/SnackStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import ConcurrencyPopUp from '../../ConcurrencyPopUp/ConcurrencyPopUp';
import { FuseConsoleCardFooter } from '../../ConsoleFragments';
import { FTBody, Page, Card, FTHeading } from '../../Fuse';
import StackL from '../../Spacers/Spacers';
import { TStrong } from '../../Text/Text';
import CustomCategoriesModal from '../CustomCategories/CustomCategoriesModal';
import PolicyTable from '../PolicyTable';
import PriorityModal from '../PriorityModal';
import ContentRulesModal from './ContentRulesModal';
import ContentRuleName from './ContentRuleName';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../../stores/ConsoleStore';
import BrowsingRoleModal from '../BrowsingRoles/BrowsingRoleModal';

class ContentRules extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        snack: SnackStore.PropType.isRequired,
        policy: PolicyStore.PropType.isRequired,
    };

    columnsConfig = {
        extraColumns: [{
            name: 'action',
            title: 'Action',
            render: (item) => <div> {item.action[0] + item.action.slice(1).toLowerCase()} </div>,
            index: PolicyTable.COL_INDEXES.DESCRIPTION + 1,
        }]
    };

    componentDidMount = () => {
        this.props.policy.contentRules.policyTable.policyModal.sections.matchCriteria.preload();
    }

    renderTable = (priorityMode) => <PolicyTable
        changePriorityAction
        store={this.props.policy.contentRules.policyTable}
        snack={this.props.snack}
        priorityMode={priorityMode}
        searchPlaceholder="Search by Name"
        noItemsText="adding a content rule"
        itemName="Rule"
        itemNameFull="Content Rule"
        loadFailedMessage="Failed to load rules."
        readOnly={this.props.console.authority === ROLE_READ_ONLY.value}
        columnsConfig={this.columnsConfig}
        renderName={({ name, isDefault }) => <ContentRuleName name={name} isDefault={isDefault} />}
    />;

    renderAboutSection = () => {
        return <Card title="What are Content Rules?">
            <FTBody>
                Content Rules either block page content in
                Isolation or allow it with defined page restrictions/permissions.
            </FTBody>
            <StackL />
            <FTHeading>When are Content Rules Applied? </FTHeading>
            <StackL />
            <FTBody>
                When a user requests a URL, the system detects the request attributes and applies a Policy.
                If there are no matching Exclusion Rules, the system will enforce the
                highest-matching Content Rule if the URL opens in Isolation.
            </FTBody>
            <StackL />

            <FTHeading>How to Use Content Rules</FTHeading>
            <StackL />
            <FTBody><TStrong>Step 1. Edit the Default Content Rule</TStrong></FTBody>
            <StackL />
            <FTBody>
                This establishes the baseline content and security settings for all pages in Isolation.
                The Default Content Rule applies to all pages, is always enabled,
                and always operates at the lowest priority.
            </FTBody>
            <StackL />
            <FTBody><TStrong>Step 2. Add new Content Rules</TStrong></FTBody>
            <StackL />
            <FTBody>
                Name the Rule, then specify its Match Criteria and Action: Block or Allow with Page Controls.
                This is how you create exceptions to the Default Content Rule.
            </FTBody>
            <StackL />
            <FTBody><TStrong> Step 3. Stack-rank Content Rules in the Console </TStrong></FTBody>
            <StackL />
            <FTBody>
                Rules are applied based on priority. Only the highest-ranking Rule with matching criteria is applied.
                This allows you to create Rules with specific exemptions that will override more broad Rules.
            </FTBody>
            <StackL />
            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            <FTBody>
                To ensure your HR acceptable use policy is replicated in Isolation,
                create a Content Rule that will Block all users from accessing the
                Custom Category for your &quot;Sites that Violate HR Policy.&quot;
            </FTBody>
            <StackL />
            <FuseConsoleCardFooter
                text={`If no Content Rules are added,
                    the system enforces the default Content Rule for all URLs in Isolation.`}
            />
        </Card>;
    }

    render() {
        const { policyTable } = this.props.policy.contentRules;
        return <Fragment>
            <Page title="Policies - Content Rules">
                {this.renderTable()}
                {this.renderAboutSection()}
            </Page>
            <ContentRulesModal />
            <BrowsingRoleModal />
            <CustomCategoriesModal />

            <PriorityModal
                store={policyTable}
                subTitle={' - Content Rules'}
                errMsg={'Failed to change rules priorities'}
            >
                {this.renderTable(true)}
            </PriorityModal>

            <ConcurrencyPopUp
                store={policyTable.concurrencyPopUpStore}
                revisionType={RULE_REC_TYPE.CONTENT_RULES}
            />
        </Fragment>;
    }
}

export default inject('console', 'snack', 'policy')(observer(ContentRules));
